const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoChannel4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1024 351",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1",
    transform: "matrix(0.939386,0,0,0.939386,31.0344,10.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path45824",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.538,309.4L375.538,512.695L203.735,724.836L39.183,724.836L375.538,309.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path45820",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.131,
    y: 1234.84,
    width: 127.237,
    height: 127.599,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path45816",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.001,
    y: 1235.01,
    width: 285.372,
    height: 127.595,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path45812",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.372,
    y: 972.025,
    width: 127.961,
    height: 390.409,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path45808",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 784.675,
    width: 563.333,
    height: 127.595,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path45804",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 810.517,
    y: 784.557,
    width: 196.201,
    height: 127.595,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path45800",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.596,175.672L750.596,1175.17L622.997,1175.17L622.997,333.271L750.596,175.672Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path45796",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.333,77.454L563.333,724.836L435.372,724.836L435.372,235.498L563.333,77.454Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path45792",
    transform: "matrix(0.237274,0,0,0.237274,392.566,13.7332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.629,-0L744.881,87.649L623.001,238.054L623.001,16.826L636.629,-0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoChannel4);
export default __webpack_public_path__ + "static/media/logo-channel4.8212b7636c03d28cee5d631ee1714132.svg";
export { ForwardRef as ReactComponent };